import { KVSSizeOptions } from 'Types/Aggregates';

const EN13053_DP_MAX_FILTER_PA = 100;

export const formatAggregateCalcData = (
  params: { [key: string]: any },
  isMultiple = false,
  includeAddons = false
) => {
  const p = { ...params };
  const kelvinDiff = 273.15;
  /*
			ProductFilters.defaultProps = {
			defaultValues: {
					'cooling.ambient.TIn': 26, // Sommer.Udeluft.Temperatur + 273.15 # Fra Celcius til Kelvin
					'cooling.indoor.TIn': 22, // Sommer.Fraluft.Temperatur + 273.15 # Fra Celcius til Kelvin
					'heating.ambient.TIn': -10, // Vinter.Udeluft.Temperatur + 273.15 # Fra Celcius til Kelvin
					'heating.indoor.TIn': 22, // Vinter.Fraluft.Temperatur + 273.15 # Fra Celcius til Kelvin
					'cooling.ambient.RHIn': 80, // Sommer.Udeluft.Luftfugtighed / 100.0 # Fra % 0-100 til ratio 0-1
					'cooling.indoor.RHIn': 60, // Sommer.Fraluft.Luftfugtighed / 100.0 # Fra % 0-100 til ratio 0-1
					'heating.ambient.RHIn': 80, //  Vinter.Udeluft.Luftfugtighed / 100.0 # Fra % 0-100 til ratio 0-1
					'heating.indoor.RHIn': 40, // Vinter.Fraluft.Luftfugtighed / 100.0 # Fra % 0-100 til ratio 0-1
					active_cooling: true,
					heating_surface: false,
					recirculation_module: false,
					supply_filter: 1,
					discharge_filter: 1,
					// '14': 250, // TODO: what is this?
					'cooling.indoor.VIn': 5000, // Luftmængder.Fraluft / 3600.0 # Fra m3/h til m3/s
					'dp_external.discharge_air': 250,
					'cooling.ambient.VIn': 5000, // Luftmængder.Tilluft / 3600.0 # Fra m3/h til m3/s
					'dp_external.supply_air': 250,
			},
			};
	*/

  // reheater confing
  p['reheater_config.coil_supply'] += kelvinDiff;
  p['reheater_config.coil_return'] += kelvinDiff;
  p['reheater_config.coil_concentration'] /= 100;

  p['cooling.ambient.TIn'] += kelvinDiff;
  p['cooling.indoor.TIn'] += kelvinDiff;
  p['cooling.indoor.TOut'] += kelvinDiff;
  /* p['cooling.indoor.calcTOut'] = true; */

  p['heating.ambient.TIn'] += kelvinDiff;
  p['heating.indoor.TIn'] += kelvinDiff;
  p['heating.indoor.TOut'] += kelvinDiff;
  /* p['heating.indoor.calcTOut'] = true; */

  p['cooling.ambient.RHIn'] /= 100;
  p['cooling.indoor.RHIn'] /= 100;
  p['heating.ambient.RHIn'] /= 100;
  p['heating.indoor.RHIn'] /= 100;

  p['cooling.indoor.VIn'] /= 3600;
  p['cooling.ambient.VIn'] /= 3600;

  // summer and winter aiflows should be the same
  p['heating.indoor.VIn'] = p['cooling.indoor.VIn'];
  p['heating.ambient.VIn'] = p['cooling.ambient.VIn'];
  p['heating.indoor.dp_external'] = p['cooling.indoor.dp_external'];
  p['heating.ambient.dp_external'] = p['cooling.ambient.dp_external'];

  if (isMultiple) {
    p['reheater_config.reheater_type'] = 'NONE';
  } else {
    p.Kvs_sizes = KVSSizeOptions;
  }

  if (p.dp_max_filter_type === 'EN13053') {
    p.dp_max_filter = EN13053_DP_MAX_FILTER_PA;
  }
  delete p.dp_max_filter_type;

  if (!includeAddons) {
    delete p.addons;
  }

  return p;
};

export default {};
